import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "centered",
  style: {"height":"90vh"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "w100" }
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(`fr centered`),
  style: {"width":"220px","padding":"4px 10px","margin-top":"30px"}
}
const _hoisted_6 = {
  key: 0,
  class: "fw600",
  style: {"margin-bottom":"0"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "fw600",
  style: {"margin-bottom":"0"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = { class: "" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "header_title w600 fs28" }, "ファイルをアップロード", -1)
const _hoisted_21 = {
  key: 0,
  class: "fw600 dgrey centered fs13"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = {
  class: "drop",
  style: {"padding-top":"100px"}
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "drag-drop-info" }, "ここにファイルをドロップ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"16px"} }, "または", -1)
const _hoisted_28 = {
  for: "uploadText",
  class: "skyblueBg rad8 pointer fw600",
  style: {"padding":"8px 14px"}
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "w100" }
const _hoisted_32 = { class: "centered mt20" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "header_title w600 fs20" }, "新規アドレス帳グループを作成", -1)
const _hoisted_34 = {
  class: "centered mc",
  style: {"width":"400px"}
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "fw600 grey centered fs13" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = { class: "centered mt20" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "header_title w600 fs20" }, "既存のアドレス帳グループに追加", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "dgrey fs13" }, [
  /*#__PURE__*/_createTextVNode(" アドレス帳グループを選択して、アップロードしたアドレスを追加します。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 選択しない場合は、アドレス帳にのみ追加されます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1つのアドレス帳グループに登録できる件数を超過する場合は、それ以降の行の登録は無視されます。 ")
], -1)
const _hoisted_43 = {
  class: "mt10 mc ofs",
  style: {"width":"400px","height":"300px"}
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 0,
  class: "posAb skyblue fs20",
  style: { width: `30px`, top: `8px`, left: `20px` }
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", null, "✔", -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "dgrey fs12 fl mt3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_52 = {
  class: "centered mt20 mc",
  style: {"width":"600px"}
}
const _hoisted_53 = { key: 2 }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "w100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "header_title w600 fs28" }, "アップロードが完了しました")
], -1)
const _hoisted_55 = [
  _hoisted_54
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "UploadModal",
    "content-class": "rad10 pad15 with_white_bg ofs shadowContent modalWide noscroll",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          class: "dismiss",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissModal && _ctx.dismissModal(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
            width: "50",
            height: "50"
          }, null, 8, _hoisted_2)
        ]),
        (_ctx.pageNum == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", _hoisted_5, [
                  (_ctx.type == `room`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createTextVNode("  調整ページ一括作成用の"),
                        _hoisted_7,
                        _createTextVNode("テンプレートをダウンロード "),
                        _createElementVNode("div", {
                          class: "circle_button fs12 blueAround centered noborder pad0",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadCSV(`csv`)))
                        }, [
                          _createTextVNode(" CSV"),
                          _hoisted_8,
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/download.png`),
                            width: "18",
                            height: "23",
                            style: {"margin-top":"-2px"}
                          }, null, 8, _hoisted_9)
                        ]),
                        _createElementVNode("div", {
                          class: "circle_button fs12 blueAround centered noborder pad0",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadCSV(`xlsx`)))
                        }, [
                          _createTextVNode(" Excel"),
                          _hoisted_10,
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/download.png`),
                            width: "18",
                            height: "23",
                            style: {"margin-top":"-2px"}
                          }, null, 8, _hoisted_11)
                        ])
                      ]))
                    : (_ctx.type == `addressbook`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createTextVNode("  アドレス帳一括登録用の"),
                          _hoisted_13,
                          _createTextVNode("テンプレートをダウンロード "),
                          _createElementVNode("div", {
                            class: "circle_button fs12 blueAround centered noborder pad0",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadCSV(`csv`)))
                          }, [
                            _createTextVNode(" CSV"),
                            _hoisted_14,
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/download.png`),
                              width: "18",
                              height: "23",
                              style: {"margin-top":"-2px"}
                            }, null, 8, _hoisted_15)
                          ]),
                          _createElementVNode("div", {
                            class: "circle_button fs12 blueAround centered noborder pad0",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadCSV(`xlsx`)))
                          }, [
                            _createTextVNode(" Excel"),
                            _hoisted_16,
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/download.png`),
                              width: "18",
                              height: "23",
                              style: {"margin-top":"-2px"}
                            }, null, 8, _hoisted_17)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                (_ctx.type == `room`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createTextVNode(" CSVファイルまたはエクセルファイルをアップロードして、調整ページを一括で作成できます。 "),
                      _hoisted_22,
                      _createTextVNode("そのまま自動で送信されることはありませんので、ご安心ください。 ")
                    ]))
                  : (_ctx.type == `addressbook`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createTextVNode(" CSVファイルまたはエクセルファイルをアップロードして、アドレス帳に一括登録できます。"),
                        _hoisted_24,
                        _createTextVNode(" 必須項目に入力がない場合、その行の登録は無視されます。また既にそのアドレスが登録されている場合には、新しい情報にアップデートされます。 ")
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(`${_ctx.isDrag == `new` ? 'dragging lskyblueBg' : ``} centered w100`),
                onDragover: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', true)), ["prevent"])),
                onDragleave: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', false)), ["prevent"])),
                onDrop: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"])),
                style: {"height":"500px","margin":"0px auto"}
              }, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _hoisted_27,
                  _createElementVNode("label", _hoisted_28, [
                    _createTextVNode(" ファイルを選択 "),
                    _createElementVNode("input", {
                      type: "file",
                      class: "drop__input",
                      style: {"display":"none"},
                      id: "uploadText",
                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
                    }, null, 32)
                  ]),
                  (_ctx.fileForm)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.fileForm.fileName), 1))
                    : _createCommentVNode("", true)
                ])
              ], 34)
            ]))
          : (_ctx.pageNum == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, [
                      (_ctx.newClg.name == ``)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createVNode(_component_MdTextfieldTag, {
                              name: "アドレス帳グループ名",
                              fieldStyle: "min-width:220px;max-width:220px;",
                              style: {"height":"56px","min-width":"220px"},
                              class: "fs16 fl",
                              value: _ctx.newClgName,
                              onInputValue: _ctx.inputNewClgName,
                              required: ""
                            }, null, 8, ["value", "onInputValue"]),
                            (_ctx.newClgName.length > 0)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: "fl pointer centered circle_button skyblueBg fs12 rad8 mt20 fw600",
                                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.createNewClg && _ctx.createNewClg(...args)))
                                }, " 作成 "))
                              : _createCommentVNode("", true),
                            _hoisted_36
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("p", _hoisted_38, "「" + _toDisplayString(_ctx.newClg.name) + "」に追加します。", 1),
                            _createElementVNode("div", {
                              class: "underline pointer fw600 grey centered fs13",
                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.deleteNewClg && _ctx.deleteNewClg(...args)))
                            }, "変更")
                          ]))
                    ])
                  ]),
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayClgs, (clg, clgindex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "posRe pointer centered text-left padw10 hoverLgreyBg rad8",
                          style: {"width":"320px"},
                          key: `${clgindex}${_ctx.addClgs.length}`,
                          onClick: ($event: any) => (_ctx.clickAddClg(clg.id))
                        }, [
                          (_ctx.addClgs.includes(clg.id))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_45, _hoisted_47))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(`pointer underline fl ml30 mr5 ${_ctx.addClgs.includes(clg.id) ? `fw600 skyblue` : ``}`)
                          }, _toDisplayString(clg.name), 3),
                          _createElementVNode("p", _hoisted_48, "(" + _toDisplayString(clg.total_num) + "/" + _toDisplayString(_ctx.registerMaxNum()) + ")", 1),
                          _hoisted_49
                        ], 8, _hoisted_44))
                      }), 128)),
                      _hoisted_50
                    ])
                  ]),
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("p", {
                      class: "underline pointer fl mt10",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.uploadAnyway(`none`)))
                    }, "なにもせずそのままアップロード"),
                    _createElementVNode("p", {
                      class: "pointer centered circle_button skyblueBg fs12 rad8 ml20 fw600",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.uploadAnyway(`add`)))
                    }, " アップロードしてアドレス帳グループにも追加 ")
                  ])
                ])
              ]))
            : (_ctx.pageNum == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55))
              : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}